import { useMemo } from 'react';
import { Text, TextInput, tokens } from '@hotjar/hotsauce';
import styled from '@emotion/styled';
import {
  RadioTextFilterOperation,
  readableRadioTextOperations,
  ValidationErrorEnum,
} from './GenericRadioTextType';
import { GenericFilterSelect } from '../GenericFilterSelect/GenericFilterSelect';
import type { InfoFooter } from '../GenericFilterSelect/GenericFilterSelectType';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${tokens.spacer.x2};
`;

const SelectWrapper = styled.div`
  display: flex;
  gap: ${tokens.spacer.x1};
  white-space: nowrap;
  align-items: center;
`;

const InputContainer = styled.div``;

const ErrorContainer = styled.div`
  margin-top: ${tokens.spacer.x0};
`;

interface GenericSelectTextBodyProps {
  operation?: RadioTextFilterOperation;
  operationOptions: RadioTextFilterOperation[];
  onOperationChange: (newValue: RadioTextFilterOperation) => void;
  stringValue: string;
  onStringChange: (newValue: string) => void;
  placeholders?: Partial<Record<RadioTextFilterOperation, string>>;
  propertyName?: string;
  validationError?: ValidationErrorEnum;
  infoFooter?: InfoFooter;
}

export function GenericSelectTextBody({
  operation,
  onOperationChange,
  stringValue,
  onStringChange,
  operationOptions = [],
  propertyName,
  placeholders,
  validationError,
  infoFooter,
}: GenericSelectTextBodyProps): JSX.Element {
  const optionList = useMemo(() => {
    return operationOptions.map((item) => ({
      value: item,
      label: readableRadioTextOperations[item],
    }));
  }, [operationOptions]);

  return (
    <Wrapper>
      <SelectWrapper>
        <div>where {propertyName ?? 'it'}</div>
        <GenericFilterSelect
          value={operation}
          onChange={onOperationChange}
          optionList={optionList}
          isInvalid={validationError === ValidationErrorEnum.SELECT_ONE_OPTION}
          infoFooter={infoFooter}
        />
      </SelectWrapper>
      {validationError === ValidationErrorEnum.SELECT_ONE_OPTION && (
        <Text textColor="text_error">{validationError}</Text>
      )}
      {operation != null &&
        operation !== RadioTextFilterOperation.IS_UNKNOWN &&
        operation !== RadioTextFilterOperation.HAS_ANY_VALUE && (
          <InputContainer>
            <TextInput
              placeholder={placeholders ? placeholders[operation] : ''}
              value={stringValue}
              onChange={(e) => onStringChange(e.target.value)}
              isInvalid={
                validationError === ValidationErrorEnum.TEXT_TOO_SHORT ||
                validationError === ValidationErrorEnum.TEXT_EMPTY
              }
              autoFocus
            />
            {(validationError === ValidationErrorEnum.TEXT_TOO_SHORT ||
              validationError === ValidationErrorEnum.TEXT_EMPTY) && (
              <ErrorContainer>
                <Text textColor="text_error">{validationError}</Text>
              </ErrorContainer>
            )}
          </InputContainer>
        )}
    </Wrapper>
  );
}
